import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** Markdown property - Definition */
export class DocsBlockMarkdownPropertyDefinition extends DocsBlockPropertyDefinition {
}
